/**
 * @generated SignedSource<<42c3d264e38ba2ffd7c2005c939d1c8c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CloudStorageProvider = "GOOGLE_DRIVE" | "ONEDRIVE" | "%future added value";
export type cloudProviderQueriesProvidersQuery$variables = {};
export type cloudProviderQueriesProvidersQuery$data = {
  readonly viewer: {
    readonly id: string;
    readonly cloudStorageProviders: ReadonlyArray<{
      readonly provider: CloudStorageProvider;
      readonly clientId: string;
      readonly pickerApiKey: string | null;
      readonly appId: string | null;
      readonly redirectUri: string;
      readonly connection: {
        readonly accountEmail: string;
        readonly status: string;
      } | null;
    }>;
  } | null;
};
export type cloudProviderQueriesProvidersQuery = {
  variables: cloudProviderQueriesProvidersQuery$variables;
  response: cloudProviderQueriesProvidersQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Viewer",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CloudStorageProviderConfig",
        "kind": "LinkedField",
        "name": "cloudStorageProviders",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "provider",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pickerApiKey",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "redirectUri",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CloudStorageConnection",
            "kind": "LinkedField",
            "name": "connection",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "cloudProviderQueriesProvidersQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "cloudProviderQueriesProvidersQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "5b6aa05d08c2906ae4a35c9e65d927bb",
    "id": null,
    "metadata": {},
    "name": "cloudProviderQueriesProvidersQuery",
    "operationKind": "query",
    "text": "query cloudProviderQueriesProvidersQuery {\n  viewer {\n    id\n    cloudStorageProviders {\n      provider\n      clientId\n      pickerApiKey\n      appId\n      redirectUri\n      connection {\n        accountEmail\n        status\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bcc53f08a7bdba4bab4e32d6e390b8ed";

export default node;
